import { c as e } from "../chunks/fields.B8wePlrI.js";
import { actionHandler as t } from "./lib/actionHandler.es.js";
import { TableIcon as n } from "lucide-react";
import { jsx as r } from "react/jsx-runtime";
// lib/TVListing/index.tsx
var i = (i) => ({
	class: "block",
	name: "tt/tv-listing",
	options: i,
	actions: [{
		name: "tt/tv-listing",
		title: "Tablåinfo",
		tool: () => /* @__PURE__ */ r(n, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: t,
		visibility: () => [
			!0,
			!0,
			!1
		]
	}],
	componentEntry: e()
});
export { i as TVListing };
